// export const getCachedPage = cache(async (path: string, req: IncomingMessage) => {
//   return serverSideFetch<Page | null>(req, textVariableReplacer(urls.content.aliasContent, { path }), {});
// });

export const getExcerptWithoutHtml = (html: string, length: number) => {
  const div = document.createElement('div');
  div.innerHTML = html;
  const text = div.textContent || div.innerText || '';
  if (text.length <= length) {
    return text;
  }
  return text.substring(0, length) + '...';
};
